import { render, staticRenderFns } from "./AddClientFormVoluntary.vue?vue&type=template&id=24f74ea0&scoped=true&"
import script from "./AddClientFormVoluntary.vue?vue&type=script&lang=js&"
export * from "./AddClientFormVoluntary.vue?vue&type=script&lang=js&"
import style0 from "./AddClientFormVoluntary.vue?vue&type=style&index=0&id=24f74ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f74ea0",
  null
  
)

export default component.exports